module.exports = __webpack_public_path__ + "img/ampel_grün.8d355da3.svg";